interface Measurable {
  getBoundingClientRect: () => { left: number; right: number };
}

/**
 * The `scrollLeft` needed to keep the active item fully visible with the least
 * movement: scroll left when it sits off the left edge, right when it sits off
 * the right edge, and leave the position untouched when it is already in view.
 * Returns `0` when there is no active item, which also resets the strip to the
 * start. Expressed relative to the current scroll offset so it tracks the live
 * viewport.
 */
export const getActiveItemScrollLeft = (
  container: Measurable & { clientWidth: number; scrollLeft: number },
  active: Measurable | null,
): number => {
  if (!active) {
    return 0;
  }

  const containerLeft = container.getBoundingClientRect().left;
  const activeRect = active.getBoundingClientRect();
  const relativeLeft = activeRect.left - containerLeft;
  const relativeRight = activeRect.right - containerLeft;

  if (relativeLeft < 0) {
    return Math.max(0, container.scrollLeft + relativeLeft);
  }

  if (relativeRight > container.clientWidth) {
    return Math.max(0, container.scrollLeft + (relativeRight - container.clientWidth));
  }

  return container.scrollLeft;
};
